const ABFieldJSONCore = require("../../core/dataFields/ABFieldJsonCore");
module.exports = class ABFieldJSON extends ABFieldJSONCore {};
